"use strict";
const vue = require("vue");
const _hoisted_1 = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m14.057 23 1.886 1.885 8.942-8.942L15.943 7l-1.886 1.885 5.724 5.724H7v2.667h12.781L14.057 23z",
  fill: "currentcolor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function render(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1, _hoisted_3);
}
const ArrowRight = { render };
exports.ArrowRight = ArrowRight;
